import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "audiosContainer"
};
const _hoisted_2 = {
  key: 0,
  class: "exhitbtionImgBox"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "exhibition-box exhibition-container"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "typebox-col1"
};
const _hoisted_7 = {
  key: 0,
  class: "type"
};
const _hoisted_8 = {
  class: "type-name"
};
const _hoisted_9 = {
  key: 1,
  class: "type"
};
const _hoisted_10 = {
  class: "type-name"
};
const _hoisted_11 = {
  key: 0,
  class: "typebox-col2"
};
const _hoisted_12 = {
  class: "type"
};
const _hoisted_13 = {
  class: "type-name"
};
const _hoisted_14 = {
  class: "exhibiton-content"
};
const _hoisted_15 = {
  class: "listTab"
};
const _hoisted_16 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_guideTheme = _resolveComponent("guideTheme");
  const _component_audioItemv2 = _resolveComponent("audioItemv2");
  const _component_van_list = _resolveComponent("van-list");
  const _component_hysbwg = _resolveComponent("hysbwg");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`audios ${_ctx.$route.query.searchKey ? 'searchKey' : ''}`)
  }, [_createVNode(_component_guideTheme), _createElementVNode("div", _hoisted_1, [!_ctx.$route.query.searchKey ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
    src: $options.getImg($data.detail.images, 0, 0),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.showBigImg && $options.showBigImg(...args))
  }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [!_ctx.$route.query.searchKey ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_5, _toDisplayString($data.language ? $data.detail.en_name : $data.detail.exhibName), 1), _createElementVNode("div", _hoisted_6, [!(_ctx.$route.query.fid == 47792 && !$data.detail.price) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[3] || (_cache[3] = _createElementVNode("i", {
    class: "icon-cost"
  }, null, -1)), _createElementVNode("div", _hoisted_8, _toDisplayString($data.detail.price === '' ? '免费' : $data.detail.price), 1)])) : _createCommentVNode("", true), $data.detail.exhibType ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[4] || (_cache[4] = _createElementVNode("i", {
    class: "icon-exhibit"
  }, null, -1)), _createElementVNode("div", _hoisted_10, _toDisplayString(!$data.language ? $data.detail.exhibType : $options.getType($data.detail.exhibType)), 1)])) : _createCommentVNode("", true)]), $data.detail.exhibitionLocation ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[5] || (_cache[5] = _createElementVNode("i", {
    class: "icon-address"
  }, null, -1)), _createElementVNode("div", _hoisted_13, _toDisplayString($data.language ? $data.detail.en_location : $data.detail.exhibitionLocation), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
    id: "desc",
    class: _normalizeClass(`txtcon ${$data.isFolded && $data.descflag ? 'hide' : ''}`)
  }, [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
    class: "richtext",
    id: "editor1"
  }, null, -1)]))], 2), _withDirectives(_createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = (...args) => $options.toggleFold && $options.toggleFold(...args)),
    class: _normalizeClass(`state ${$data.isFolded ? 'nofold' : 'fold'}`)
  }, [_createElementVNode("span", null, _toDisplayString($data.isFolded ? `${this.language ? 'all' : '展开全部'}` : `${this.language ? 'expand all' : '收起'}`), 1), _createElementVNode("i", {
    class: _normalizeClass(["icon-arrow-bottom1", {
      'up': !$data.isFolded
    }])
  }, null, 2)], 2), [[_vShow, $data.descflag]])])], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, i => {
    return _createElementVNode("div", {
      onClick: $event => $data.audioType = i,
      class: _normalizeClass(`${$data.audioType == i ? 'audioType_a' : ''}`)
    }, null, 10, _hoisted_16);
  }), 64))]), _createVNode(_component_van_list, {
    loading: $data.loading,
    "onUpdate:loading": _cache[2] || (_cache[2] = $event => $data.loading = $event),
    finished: $data.finished,
    "finished-text": $data.total > 20 ? '已经到底了' : '',
    onLoad: $options.onLoad
  }, {
    default: _withCtx(() => [_createVNode(_component_audioItemv2, {
      audioList: $data.audioList,
      formData: $data.formData,
      language: $data.language,
      version: "v2",
      audioType: $data.audioType
    }, null, 8, ["audioList", "formData", "language", "audioType"])]),
    _: 1
  }, 8, ["loading", "finished", "finished-text", "onLoad"])])]), _createVNode(_component_hysbwg, {
    name: "audiosv2",
    type: "audio"
  })], 2);
}